import React from 'react'
import PropTypes from 'prop-types'

import { useGetQuery } from '../../lib/api/get'
import { useCreateCall } from '../../lib/api/create'
import { useUpdateCall } from '../../lib/api/update'
import { ExamScheduleForm } from './ExamScheduleForm'
import { ScheduleForm } from './ScheduleForm'

export const ExamSchedule = ({ setOpenFormModal, formSchema, isLocalEnvironment }) => {
  const getData = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'syllabusCombination',
    params: '',
    isDynamic: true,
  })
  const [expandExam, setExpandExam] = React.useState(null)
  const [expandSubsExam, setExpandSubsExam] = React.useState(null)
  const [addScheduleModal, setAddScheduleModal] = React.useState(false)
  const [addScheduleModalData, setAddScheduleModalData] = React.useState(null)
  const [createExamScheduleLoading, setCreateExamScheduleLoading] = React.useState(false)

  const [activeAY, setActiveAY] = React.useState(null)
  const createCallMutation = useCreateCall()
  const updateCallMutation = useUpdateCall()

  const scheduleAdd = (data) => {
    setAddScheduleModalData(data)
    setAddScheduleModal(true)
  }

  const scheduleAddClose = () => {
    setAddScheduleModalData(null)
    setAddScheduleModal(false)
  }

  const onSubmit = async (data, selectedExam, syl) => {
    const temObj = {}
    for (var key in data) {
      if (data[key]) {
        temObj[key.split('-')[0]] = data[key]
      }
    }

    const formData = temObj //JSON.parse(data)
    formData['examDate'] = temObj.examDate
    formData['examStartTime'] = temObj.examDate + ' ' + temObj.examStartTime
    formData['examEndTime'] = temObj.examDate + ' ' + temObj.examEndTime
    formData.syllabusCombinationSubjectExamId =
      JSON.parse(selectedExam).subjectExams[0].syllabusCombinationSubjectExamId
    formData.classSectionId = syl.classSections[0].classSectionId
    formData['academicYearId'] = activeAY

    await createCallMutation.mutateAsync({
      url: isLocalEnvironment + '/addData',
      apiEndpoint: 'syllabusCombinationSubjectExamSchedule',
      parentAPI: 'syllabusCombination',
      data: formData,
      messageTitle: 'Exams',
      message: 'Exam added successfully!',
      params: '',
      isDynamic: true,
    })
  }

  const onUpdate = async (scheduleData, data) => {
    const temObj = {}
    for (var key in scheduleData) {
      if (scheduleData[key]) {
        temObj[key.split('-')[0]] = scheduleData[key]
      }
    }
    const formData = data
    formData['examDate'] = temObj.examDate
    formData['examStartTime'] = temObj.examDate + ' ' + temObj.examStartTime
    formData['examEndTime'] = temObj.examDate + ' ' + temObj.examEndTime
    await updateCallMutation.mutateAsync({
      url: isLocalEnvironment + '/updateData',
      apiEndpoint: 'syllabusCombinationSubjectExamSchedule',
      parentAPI: 'syllabusCombination',
      data: formData,
      id: formData.syllabusCombinationSubjectExamScheduleId,
      messageTitle: 'Exam Schedules',
      message: 'Exam schedule updated!',
      params: '',
      isDynamic: true,
    })
  }

  const onCreateExamSchedule = async () => {
    setCreateExamScheduleLoading(true)
    await createCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/addData',
        apiEndpoint: 'syllabusCombinationSubjectExamSchedule/generate',
        parentAPI: 'syllabusCombination',
        data: { academicYearId: activeAY },
        messageTitle: 'Exams',
        message: 'Exam schedule created successfully!',
        params: '',
        isDynamic: true,
      })
      .then(() => setCreateExamScheduleLoading(false))
      .catch(() => setCreateExamScheduleLoading(false))
  }

  const ayDep =
    JSON.parse(sessionStorage.getItem('auth')).state.dependeciesFormAPIS.academicYears || []

  if (getData.isLoading) {
    return (
      <div
        className="trtui-modal trtui-modal-xl trtui-fade trtui-show"
        aria-labelledby="exampleModalLabel"
        style={{ display: 'block', backgroundColor: 'rgba(55,55,55,0.3)' }}
        aria-modal="true"
        role="dialog"
      >
        <div className="trtui-modal-dialog trtui-modal-xl">
          <div className="trtui-modal-content">
            <div className="trtui-modal-header trtui-bg-light trtui-p-3">
              <h5 className="trtui-modal-title" id="exampleModalLabel">
                {formSchema.formTitle}
              </h5>
              <button
                type="button"
                className="trtui-btn-close"
                onClick={() => {
                  setOpenFormModal(false)
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ri-close-line" />
              </button>
            </div>
            <div className="trtui-modal-body">
              <div>
                <div
                  id="status"
                  className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
                  style={{
                    width: '40px',
                    height: '40px',
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    margin: '-20px 0 0 6.4rem',
                  }}
                >
                  <div
                    className="trtui-spinner-border trtui-text-primary trtui-avatar-sm"
                    role="status"
                  >
                    <span className="trtui-visually-hidden">Loading...</span>
                  </div>
                </div>
                <div
                  id="status"
                  className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
                  style={{
                    width: '40px',
                    height: '40px',
                    position: 'absolute',
                    left: '20%',
                    top: '50%',
                    margin: '-20px 0 0 6.4rem',
                  }}
                >
                  <div
                    className="trtui-spinner-border trtui-text-primary trtui-avatar-sm"
                    role="status"
                  >
                    <span className="trtui-visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div
      className="trtui-modal trtui-modal-xl trtui-fade trtui-show"
      aria-labelledby="exampleModalLabel"
      style={{ display: 'block', backgroundColor: 'rgba(55,55,55,0.3)' }}
      aria-modal="true"
      role="dialog"
    >
      <div className="trtui-modal-dialog trtui-modal-xl">
        <div className="trtui-modal-content">
          <div className="trtui-modal-header trtui-bg-light trtui-p-3">
            <h5 className="trtui-modal-title" id="exampleModalLabel">
              Exam Schedule
            </h5>
            <button
              type="button"
              className="trtui-btn-close"
              onClick={() => {
                setOpenFormModal(false)
              }}
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="trtui-modal-body">
            <div className="trtui-accordion trtui-custom-accordionwithicon trtui-accordion-secondary">
              <div className={`trtui-col-md-3`}>
                <label className="trtui-form-label">Academic Year</label>
                <select
                  className={`trtui-form-control trtui-mb-2`}
                  style={{
                    paddingRight: 'calc(1.5em + 1rem)',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                    backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                  }}
                  onChange={(e) => setActiveAY(e.target.value)}
                >
                  <option value={''}>Select AY</option>
                  {ayDep.formData?.map((ay, ayInd) => (
                    <option key={ayInd} value={ay.academicYearId}>
                      {ay.academicYearName}
                    </option>
                  ))}
                </select>
              </div>
              {activeAY && (
                <button
                  type="button"
                  onClick={() => onCreateExamSchedule()}
                  disabled={createExamScheduleLoading ? true : false}
                  className="trtui-btn trtui-btn-primary trtui-btn-sm trtui-mb-3"
                >
                  {createExamScheduleLoading ? (
                    <span className="trtui-d-flex trtui-align-items-center">
                      <span className="trtui-flex-grow-1 trtui-me-2">Creating...</span>
                      <span className="trtui-spinner-border trtui-flex-shrink-0" role="status">
                        <span className="trtui-visually-hidden">Creating...</span>
                      </span>
                    </span>
                  ) : (
                    'Create Schedule'
                  )}
                </button>
              )}
              {!createExamScheduleLoading &&
                getData.data?.formData?.length &&
                getData.data?.formData?.length > 0 &&
                getData.data?.formData?.map((syl, sylInd) => (
                  <div key={sylInd} className="trtui-accordion-item">
                    <h2
                      className="trtui-accordion-header"
                      onClick={() => setExpandExam(expandExam === sylInd ? null : sylInd)}
                    >
                      <button
                        className="trtui-accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#accor_iconExamplecollapse1"
                        aria-expanded="true"
                        aria-controls="accor_iconExamplecollapse1"
                      >
                        {syl.syllabusCombinationName}
                      </button>
                    </h2>
                    <div
                      id="accor_iconExamplecollapse1"
                      className={`trtui-accordion-collapse trtui-collapse ${sylInd === expandExam ? 'trtui-show' : ''}`}
                      aria-labelledby="accordionwithiconExample1"
                      data-bs-parent="#accordionWithicon"
                    >
                      <div className="trtui-accordion-body">
                        {syl.combinationSubjects?.map((subs, subdInd) => (
                          <div
                            key={subdInd}
                            className="trtui-accordion trtui-custom-accordionwithicon-plus"
                          >
                            <div className="trtui-accordion-item">
                              <h2
                                className="trtui-accordion-header"
                                onClick={() =>
                                  setExpandSubsExam(expandSubsExam === subdInd ? null : subdInd)
                                }
                              >
                                <button className="trtui-accordion-button" type="button">
                                  {subs.subjects.subjectName}
                                </button>
                              </h2>
                              <div
                                className={`trtui-accordion-collapse trtui-collapse ${subdInd === expandSubsExam ? 'trtui-show' : ''}`}
                              >
                                <div className="trtui-accordion-body">
                                  {activeAY !== null ? (
                                    <>
                                      <button
                                        type="button"
                                        className="trtui-btn trtui-btn-primary trtui-btn-sm trtui-mb-3"
                                        onClick={() => {
                                          addScheduleModal ? scheduleAddClose() : scheduleAdd(subs)
                                        }}
                                      >
                                        Add Schedule
                                      </button>
                                      {addScheduleModal && (
                                        <ScheduleForm
                                          addScheduleModalData={addScheduleModalData}
                                          onSubmit={onSubmit}
                                          syl={syl}
                                        />
                                      )}
                                      {subs.syllabusCombinationSubjectExams
                                        .sort(
                                          (a, b) =>
                                            a.exam.examGroup.displayOrder -
                                              b.exam.examGroup.displayOrder ||
                                            a.exam.displayOrder - b.exam.displayOrder,
                                        )
                                        .map((exm, exmInd) => (
                                          <div key={exmInd}>
                                            {exm.exam.examGroup.examGroupName} - {exm.exam.examName}
                                            {exm.examSchedule?.academicYearId === activeAY && (
                                              <ExamScheduleForm
                                                key={exmInd}
                                                id={exmInd}
                                                onSubmit={onSubmit}
                                                onUpdate={onUpdate}
                                                exmInd={exmInd}
                                                exm={exm}
                                                syl={syl}
                                              />
                                            )}
                                          </div>
                                        ))}
                                    </>
                                  ) : (
                                    <span>Please select AY</span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ExamSchedule.propTypes = {
  setOpenFormModal: PropTypes.func,
  formSchema: PropTypes.object,
  isLocalEnvironment: PropTypes.string,
}
